import { env } from '@/config/host';
import { CoupeSDK } from '@xl/coupe-sdk';
import {
  safeUrlBase64Encrypt,
  safeUrlBase64Decrypt,
  safeParse,
} from '@xl/secure-transfer-sdk';
import { AppModule } from '@/store/modules/app';

class Encryption {
  private sdk;
  private encryptHeaders = {
    /**
     * 告诉网关request body已经加密
     */
    req_encrypt: {
      'x-reqe1f2a3b4': 'true',
    },
    /**
     * 告诉网关返回数据需要加密
     */
    res_encrypt: {
      'x-accrespf5g6h7i8': 'true',
    },
  };
  constructor() {
    this.sdk = new CoupeSDK<{
      encryptSwitch: boolean;
      mapEncryptSwitch: boolean;
    }>({
      coupeId: '00d1dfbb363d4811afeed9d30c2d0061',
      timeout: 2000,
      env,
    });
  }

  isUseEncry() {
    const os = 'xl_wxa';
    return AppModule.urlParams?.client_type === os
  }

  /**
   * 获取coupe配置
   */
  async fetchEncryptSwitch() {
    let res;
    try {
      res = await this.sdk.fetch();
    } catch (error) {
      console.log(error);
    }

    if (res) {
      return res.encryptSwitch;
    }

    return true;
  }

  /**
   * 是否开启加密功能
   */
  async isOpenEncryption() {
    if (this.isUseEncry()) {
      const encryptSwitch = await this.fetchEncryptSwitch();

      return typeof encryptSwitch === 'boolean' ? encryptSwitch : true;
    }

    return false;
  }

  /**
   * 追加请求加密header字段
   */
  async getReqEncryptHeaders() {
    if (await this.isOpenEncryption()) {
      return this.encryptHeaders.req_encrypt;
    }
    return undefined;
  }

  /**
   * 追加响应加密header字段
   */
  async getResEncryptHeaders() {
    if (await this.isOpenEncryption()) {
      return this.encryptHeaders.res_encrypt;
    }
    return undefined;
  }

  /**
   * 智能解析经纬度，失败则返回原数据
   */
  safeParse(text: string) {
    if (!text) {
      return '';
    }

    if (!this.isUseEncry()) {
      return text;
    }

    const parseData = safeParse(text);

    return parseData || text;
  }

  /**
   * 手动解密,失败返回原数据
   */
  safeUrlBase64Decrypt(text: string) {
    if (!text) {
      return '';
    }

    if (!this.isUseEncry()) {
      return text;
    }

    const data = safeUrlBase64Decrypt(text) || '';

    let res = ''

    try {
      res = JSON.parse(data);
    } catch (error) {
      return res;
    }

    return res;
  }

  /**
   * 手动加密,失败返回原数据
   */
  safeUrlBase64Encrypt(text: string) {
    if (!text) {
      return '';
    }

    if (!this.isUseEncry()) {
      return text;
    }

    const enCriptData = safeUrlBase64Encrypt(text);

    return enCriptData || text;
  }

  /**
   * 是否存在请求加密头
   * true: 前端需要对请求进行加密
   */
  isExitReqEncryptHeader(headers: Record<string, any>) {
    return Boolean(headers?.['x-reqe1f2a3b4']);
  }

  /**
   * 是否存在响应解密头
   * true: 前端需要对响应进行解密
   */
  isExitResEncryptHeader(headers: Record<string, any>) {
    return Boolean(headers?.['x-respj9k0l1m2']);
  }

  formatReqEnscryptData(data: Record<string, any>) {
    return { args: this.safeUrlBase64Encrypt(JSON.stringify(data)) };
  }
}

export default new Encryption();
